module.exports = __webpack_public_path__ + "img/bm.8da8375d.svg";